import React from "react";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";
import PropTypes from "prop-types";

// Material UI Components
import MenuItem from "@mui/material/MenuItem";

import Select from "components/selects/Select/Select.component";

import {
  getPathnameItem,
  addOrUpdateSlugValue,
  replaceSlugAndQuery,
} from "helpers/inventory-filters";

import { useStyles } from "../FilterMenu/FilterMenu.styles";

const FilterOption = ({
  keyName,
  defaultValueLabel,
  isDisabled,
  attributes,
  clearInventoryCards,
  ...rest
}) => {
  const router = useRouter();
  const { slug } = router.query;
  const desktopView = useSelector((state) => state.global.desktopView);

  const value = getPathnameItem(slug, keyName) || "";
  const MenuComponent = desktopView ? MenuItem : "option";

  const filterModelsByMake = () => {
    const make = getPathnameItem(slug, "make");
    if (!make) {
      return [];
    }
    const makeId = attributes.make.find((m) => m.name === make)?.id;
    const models = attributes.model;
    const filteredModels = models.filter((model) => model.makeId === makeId);
    return filteredModels;
  };

  const options =
    keyName === "model" ? filterModelsByMake() : attributes[keyName];

  const classes = useStyles();
  return (
    <Select
      className={classes.customSelect}
      native={!desktopView}
      data-cy={`${keyName}-select`}
      displayEmpty
      disabled={isDisabled}
      value={value || ""}
      onChange={(event) => {
        clearInventoryCards();
        const newSlug = addOrUpdateSlugValue(slug, keyName, event.target.value);
        replaceSlugAndQuery(router, newSlug, router.query);
      }}
      inputProps={{
        name: `${keyName}-select`,
        id: `${keyName}-select`,
      }}
      {...rest}
    >
      <MenuComponent value="">{defaultValueLabel}</MenuComponent>
      {!isDisabled && options
        ? options.map((option) => (
            <MenuComponent
              key={option.name}
              data-cy={`${keyName}-item`}
              value={option.name}
            >
              {option.name}
            </MenuComponent>
          ))
        : "Please select the previous option"}
    </Select>
  );
};
FilterOption.propTypes = {
  keyName: PropTypes.string,
  defaultValueLabel: PropTypes.string,
  isDisabled: PropTypes.bool,
  clearInventoryCards: PropTypes.func,
};

FilterOption.defaultProps = {
  keyName: "",
  defaultValueLabel: "",
  isDisabled: false,
  clearInventoryCards: () => {},
};

export default FilterOption;
